var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-0 pa-0",staticStyle:{"justify-content":"center"},attrs:{"id":_vm.id,"height":_vm.svgHeight,"width":_vm.svgWidth,"chartData":_vm.chartData}})}
var staticRenderFns = []

export { render, staticRenderFns }